import classnames from "classnames";
import React, { InputHTMLAttributes, useMemo } from "react";

export interface Props extends InputHTMLAttributes<HTMLInputElement> {
  placeHolder: string;
  placeHolderColor?: string;
  backgroundColor?: string;
  textColor?: string;
  disabled: boolean;
  borderRadius?: string;
  borderSize?: string;
  borderColor?: string;
  paddingX?: string;
  paddingL?: string;
  paddingR?: string;
  paddingY?: string;
  paddingT?: string;
  paddingB?: string;
  width?: string;
  height?: string;
  fontFamily?: string;
  fontSize?: string;
  fontWeight?: string;
}

export const Input: React.FC<Props> = ({
  placeHolder = "Enter",
  placeHolderColor,
  backgroundColor,
  textColor = "text-white",
  disabled = false,
  borderRadius = "rounded-10",
  borderSize,
  borderColor,
  paddingX,
  paddingL,
  paddingR,
  paddingY,
  paddingT,
  paddingB,
  width,
  height,
  fontFamily,
  fontSize,
  fontWeight,
  ...props
}: Props) => {
  const getClassList = () => {
    const list = [
      backgroundColor,
      placeHolderColor,
      textColor,
      borderRadius,
      borderSize,
      borderColor,
      paddingX,
      paddingL,
      paddingR,
      paddingY,
      paddingT,
      paddingB,
      width,
      height,
      fontFamily,
      fontSize,
      fontWeight,
    ];
    return list
      .filter((i) => !["undefined", "null", "true", "false"].includes(`${i}`))
      .join(" ");
  };
  const classList = getClassList();
  return (
    <>
      <input
        {...props}
        className={`border-[transparent] ${classnames(`${classList}`, {
          "cursor-not-allowed": disabled,
        })} border-0 outline-0`}
        placeholder={placeHolder}
      ></input>
    </>
  );
};
